export const DEFAULTALLOWEDTYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv',
  'text/plain',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/json',
  'application/gzip',
  'application/x-7z-compressed',
  'application/zip',
  'application/x-rar-compressed',
  'application/vnd.rar',
  'application/x-tar',
  'application/x-zip',
  'application/x-zip-compressed',
];
